import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import LayoutStudent from './LayoutStudent';
import StudentFirstLogin from './first-login/StudentFirstLogin';
import StudentClassPage from './class/StudentClassPage';
import StudentBadgePage from './badge/StudentBadgePage';
import StudentCertificatioinPage from './certification/StudentCertificatioinPage';
import StudentHomeworkPage from './homework/StudentHomeworkPage';
import StudentProfilePage from './profile/StudentProfilePage';
import { StudentProfile } from '../../constants/types/student/profile/type';
import { StudentProfileContext } from './StudentProfileContext';
import { getStudentProfile } from '../../api/utils/student/profile/apis';
import { StudentClassDetailContextProvider } from './StudentClassDetailContext';

const RouteStudent = () => {
  const [studentProfile, setStudentProfile] = useState<StudentProfile>();
  const { pathname } = useLocation();

  useEffect(() => {
    getStudentProfile().then(setStudentProfile).catch(console.error);
  }, [pathname]);

  return (
    <StudentProfileContext.Provider
      value={{
        studentProfile: studentProfile,
        setStudentProfile: setStudentProfile,
      }}
    >
      <StudentClassDetailContextProvider>
        <Routes>
          {/* base "/student" */}
          <Route index path="/first-login" element={<StudentFirstLogin />} />
          <Route element={<LayoutStudent />}>
            {/* 내 학습 */}
            <Route
              index
              path="/"
              element={<Navigate replace to="/student/class" />}
            />
            <Route index path="/class" element={<StudentClassPage />} />

            {/* 할일 목록  */}
            <Route
              index
              path="/homework/:classId"
              element={<StudentHomeworkPage />}
            />

            {/* 획득 뱃지 */}
            <Route index path="/badge" element={<StudentBadgePage />} />

            {/* 인증제 현황 */}
            <Route
              index
              path="/certification"
              element={<StudentCertificatioinPage />}
            />

            {/* 내 정보 */}
            <Route index path="/profile" element={<StudentProfilePage />} />
          </Route>
        </Routes>
      </StudentClassDetailContextProvider>
    </StudentProfileContext.Provider>
  );
};

export default RouteStudent;
